const isVlaanderen = process.env.VUE_APP_TENANT === 'vlaanderen'

const primaryGridOperatorByMunicipalityCode = {
  '1507': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1509': {name: 'Liander', slug: 'gridoperator|liander'},
  '1525': {name: 'Liander', slug: 'gridoperator|liander'},
  '1581': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1586': {name: 'Liander', slug: 'gridoperator|liander'},
  '1598': {name: 'Liander', slug: 'gridoperator|liander'},
  '1621': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1640': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1641': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1652': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1655': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1658': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1659': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1667': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1669': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1674': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1676': {name: 'DNWG (Stedin)', slug: 'gridoperator|dnwg-stedin'},
  '1680': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1681': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1684': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1685': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1690': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1695': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1696': {name: 'Liander', slug: 'gridoperator|liander'},
  '1699': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1700': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1701': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1702': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1705': {name: 'Liander', slug: 'gridoperator|liander'},
  '1706': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1708': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1709': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1711': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1714': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1719': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1721': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1723': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1724': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1728': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1729': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1730': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1731': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1734': {name: 'Liander', slug: 'gridoperator|liander'},
  '1735': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1740': {name: 'Liander', slug: 'gridoperator|liander'},
  '1742': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1771': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1773': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1774': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1783': {name: 'Westland', slug: 'gridoperator|westland'},
  '1842': {name: 'Westland', slug: 'gridoperator|westland'},
  '1859': {name: 'Liander', slug: 'gridoperator|liander'},
  '1876': {name: 'Liander', slug: 'gridoperator|liander'},
  '1883': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1884': {name: 'Liander', slug: 'gridoperator|liander'},
  '1891': {name: 'Liander', slug: 'gridoperator|liander'},
  '1892': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1894': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1895': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1896': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1900': {name: 'Liander', slug: 'gridoperator|liander'},
  '1901': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1903': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1904': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1911': {name: 'Liander', slug: 'gridoperator|liander'},
  '1916': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1924': {name: 'DNWG (Stedin)', slug: 'gridoperator|dnwg-stedin'},
  '1926': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1930': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1931': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1940': {name: 'Liander', slug: 'gridoperator|liander'},
  '1942': {name: 'Liander', slug: 'gridoperator|liander'},
  '1945': {name: 'Liander', slug: 'gridoperator|liander'},
  '1948': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1949': {name: 'Liander', slug: 'gridoperator|liander'},
  '1950': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1952': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1954': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1955': {name: 'Liander', slug: 'gridoperator|liander'},
  '1959': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1960': {name: 'Liander', slug: 'gridoperator|liander'},
  '1961': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1963': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1966': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1969': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '1970': {name: 'Liander', slug: 'gridoperator|liander'},
  '1978': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '1979': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0677': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0352': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0279': {name: 'Liander', slug: 'gridoperator|liander'},
  '0344': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0632': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0880': {name: 'Liander', slug: 'gridoperator|liander'},
  '0189': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0302': {name: 'Liander', slug: 'gridoperator|liander'},
  '0715': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0537': {name: 'Liander', slug: 'gridoperator|liander'},
  '0358': {name: 'Liander', slug: 'gridoperator|liander'},
  '0824': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0523': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0547': {name: 'Liander', slug: 'gridoperator|liander'},
  '0317': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0301': {name: 'Liander', slug: 'gridoperator|liander'},
  '0664': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0299': {name: 'Liander', slug: 'gridoperator|liander'},
  '0233': {name: 'Liander', slug: 'gridoperator|liander'},
  '0717': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0180': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0153': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0327': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0086': {name: 'Liander', slug: 'gridoperator|liander'},
  '0845': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0014': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0935': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0678': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0277': {name: 'Liander', slug: 'gridoperator|liander'},
  '0513': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0098': {name: 'Liander', slug: 'gridoperator|liander'},
  '0928': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0847': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0164': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0861': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0216': {name: 'Liander', slug: 'gridoperator|liander'},
  '0762': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0406': {name: 'Liander', slug: 'gridoperator|liander'},
  '0451': {name: 'Liander', slug: 'gridoperator|liander'},
  '0385': {name: 'Liander', slug: 'gridoperator|liander'},
  '0268': {name: 'Liander', slug: 'gridoperator|liander'},
  '0243': {name: 'Liander', slug: 'gridoperator|liander'},
  '0294': {name: 'Liander', slug: 'gridoperator|liander'},
  '0882': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0106': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0177': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0637': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0285': {name: 'Liander', slug: 'gridoperator|liander'},
  '0203': {name: 'Liander', slug: 'gridoperator|liander'},
  '0606': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0200': {name: 'Liander', slug: 'gridoperator|liander'},
  '0744': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0246': {name: 'Liander', slug: 'gridoperator|liander'},
  '0737': {name: 'Liander', slug: 'gridoperator|liander'},
  '0267': {name: 'Liander', slug: 'gridoperator|liander'},
  '0373': {name: 'Liander', slug: 'gridoperator|liander'},
  '0439': {name: 'Liander', slug: 'gridoperator|liander'},
  '0356': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0856': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0530': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0420': {name: 'Liander', slug: 'gridoperator|liander'},
  '0405': {name: 'Liander', slug: 'gridoperator|liander'},
  '0479': {name: 'Liander', slug: 'gridoperator|liander'},
  '0629': {name: 'Liander', slug: 'gridoperator|liander'},
  '0840': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0546': {name: 'Liander', slug: 'gridoperator|liander'},
  '0917': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0363': {name: 'Liander', slug: 'gridoperator|liander'},
  '0289': {name: 'Liander', slug: 'gridoperator|liander'},
  '0088': {name: 'Liander', slug: 'gridoperator|liander'},
  '0335': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0209': {name: 'Liander', slug: 'gridoperator|liander'},
  '0399': {name: 'Liander', slug: 'gridoperator|liander'},
  '0743': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0377': {name: 'Liander', slug: 'gridoperator|liander'},
  '0614': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0597': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0313': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0141': {name: 'Coteq Netbeheer', slug: 'gridoperator|coteq-netbeheer'},
  '0501': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0766': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0310': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0060': {name: 'Liander', slug: 'gridoperator|liander'},
  '0230': {name: 'Liander', slug: 'gridoperator|liander'},
  '0096': {name: 'Liander', slug: 'gridoperator|liander'},
  '0307': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0114': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0946': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0384': {name: 'Liander', slug: 'gridoperator|liander'},
  '0858': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0569': {name: 'Liander', slug: 'gridoperator|liander'},
  '0603': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0362': {name: 'Liander', slug: 'gridoperator|liander'},
  '0512': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0312': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0118': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0965': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0375': {name: 'Liander', slug: 'gridoperator|liander'},
  '0668': {name: 'Liander', slug: 'gridoperator|liander'},
  '0232': {name: 'Liander', slug: 'gridoperator|liander'},
  '0589': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0907': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0489': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0331': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0784': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0397': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0275': {name: 'Liander', slug: 'gridoperator|liander'},
  '0090': {name: 'Liander', slug: 'gridoperator|liander'},
  '0183': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0848': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0166': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0994': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0638': {name: 'Liander', slug: 'gridoperator|liander'},
  '0308': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0415': {name: 'Liander', slug: 'gridoperator|liander'},
  '0531': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0826': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0983': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0484': {name: 'Liander', slug: 'gridoperator|liander'},
  '0855': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0417': {name: 'Liander', slug: 'gridoperator|liander'},
  '0222': {name: 'Liander', slug: 'gridoperator|liander'},
  '0437': {name: 'Liander', slug: 'gridoperator|liander'},
  '0226': {name: 'Liander', slug: 'gridoperator|liander'},
  '0938': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0150': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0753': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0197': {name: 'Liander', slug: 'gridoperator|liander'},
  '0441': {name: 'Liander', slug: 'gridoperator|liander'},
  '0119': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0758': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0085': {name: 'Liander', slug: 'gridoperator|liander'},
  '0502': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0361': {name: 'Liander', slug: 'gridoperator|liander'},
  '0765': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0355': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0777': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0575': {name: 'Liander', slug: 'gridoperator|liander'},
  '0263': {name: 'Liander', slug: 'gridoperator|liander'},
  '0168': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0796': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0416': {name: 'Liander', slug: 'gridoperator|liander'},
  '0599': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0262': {name: 'Liander', slug: 'gridoperator|liander'},
  '0171': {name: 'Liander', slug: 'gridoperator|liander'},
  '0432': {name: 'Liander', slug: 'gridoperator|liander'},
  '0703': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0059': {name: 'Liander', slug: 'gridoperator|liander'},
  '0398': {name: 'Liander', slug: 'gridoperator|liander'},
  '0851': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0147': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0865': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0534': {name: 'Liander', slug: 'gridoperator|liander'},
  '0184': {name: 'Liander', slug: 'gridoperator|liander'},
  '0202': {name: 'Liander', slug: 'gridoperator|liander'},
  '0867': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0047': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0457': {name: 'Liander', slug: 'gridoperator|liander'},
  '0431': {name: 'Liander', slug: 'gridoperator|liander'},
  '0986': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0273': {name: 'Liander', slug: 'gridoperator|liander'},
  '0269': {name: 'Liander', slug: 'gridoperator|liander'},
  '0866': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0034': {name: 'Liander', slug: 'gridoperator|liander'},
  '0037': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0074': {name: 'Liander', slug: 'gridoperator|liander'},
  '0394': {name: 'Liander', slug: 'gridoperator|liander'},
  '0376': {name: 'Liander', slug: 'gridoperator|liander'},
  '0193': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0473': {name: 'Liander', slug: 'gridoperator|liander'},
  '0353': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0957': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0756': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0221': {name: 'Liander', slug: 'gridoperator|liander'},
  '0297': {name: 'Liander', slug: 'gridoperator|liander'},
  '0553': {name: 'Liander', slug: 'gridoperator|liander'},
  '0786': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0610': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0214': {name: 'Liander', slug: 'gridoperator|liander'},
  '0828': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0163': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0050': {name: 'Liander', slug: 'gridoperator|liander'},
  '0889': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0453': {name: 'Liander', slug: 'gridoperator|liander'},
  '0175': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0448': {name: 'Liander', slug: 'gridoperator|liander'},
  '0579': {name: 'Liander', slug: 'gridoperator|liander'},
  '0213': {name: 'Liander', slug: 'gridoperator|liander'},
  '0590': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0072': {name: 'Liander', slug: 'gridoperator|liander'},
  '0785': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0944': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0345': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0450': {name: 'Liander', slug: 'gridoperator|liander'},
  '0281': {name: 'Liander', slug: 'gridoperator|liander'},
  '0626': {name: 'Liander', slug: 'gridoperator|liander'},
  '0293': {name: 'Liander', slug: 'gridoperator|liander'},
  '0988': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0879': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0748': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0820': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0296': {name: 'Liander', slug: 'gridoperator|liander'},
  '0148': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0687': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0340': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0888': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0716': {name: 'DNWG (Stedin)', slug: 'gridoperator|dnwg-stedin'},
  '0402': {name: 'Liander', slug: 'gridoperator|liander'},
  '0400': {name: 'Liander', slug: 'gridoperator|liander'},
  '0797': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0809': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0252': {name: 'Liander', slug: 'gridoperator|liander'},
  '0228': {name: 'Liander', slug: 'gridoperator|liander'},
  '0505': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0109': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0080': {name: 'Liander', slug: 'gridoperator|liander'},
  '0392': {name: 'Liander', slug: 'gridoperator|liander'},
  '0396': {name: 'Liander', slug: 'gridoperator|liander'},
  '0718': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0498': {name: 'Liander', slug: 'gridoperator|liander'},
  '0303': {name: 'Liander', slug: 'gridoperator|liander'},
  '0339': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0984': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0503': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0654': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0995': {name: 'Liander', slug: 'gridoperator|liander'},
  '0798': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0383': {name: 'Liander', slug: 'gridoperator|liander'},
  '0873': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0173': {name: 'Coteq Netbeheer', slug: 'gridoperator|coteq-netbeheer'},
  '0736': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0642': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0093': {name: 'Liander', slug: 'gridoperator|liander'},
  '0342': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0815': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0971': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0351': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0823': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0794': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0532': {name: 'Liander', slug: 'gridoperator|liander'},
  '0556': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0160': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0274': {name: 'Liander', slug: 'gridoperator|liander'},
  '0755': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0542': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0518': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0622': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0981': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0772': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0225': {name: 'Liander', slug: 'gridoperator|liander'},
  '0899': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0627': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0770': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0158': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0779': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0370': {name: 'Liander', slug: 'gridoperator|liander'},
  '0244': {name: 'Liander', slug: 'gridoperator|liander'},
  '0482': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0613': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0757': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0893': {name: 'Enexis', slug: 'gridoperator|enexis'},
  '0321': {name: 'Stedin', slug: 'gridoperator|stedin'},
  '0852': {name: 'Liander', slug: 'gridoperator|liander'},
  '0388': {name: 'Liander', slug: 'gridoperator|liander'},
}

// Source: https://totalenergies.be/nl/particulieren/hulp-en-contact/veelgestelde-vragen/elektriciteit-aardgas/mijn-netwerk/de-netbeheerders/wie-mijn-netbeheerder //
// Brussels Hoofdstedelijk Gewest gemeentes //
const municipalityCodesBrussel = [
  '21004', // Brussel
  '21015', // Schaarbeek
  '21005', // Etterbeek
  '21009', // Elsene
  '21013', // Sint-Gillis
  '21001', // Anderlecht
  '21012', // Sint-Jans-Molenbeek
  '21011', // Koekelberg
  '21003', // Sint-Agatha-Berchem
  '21008', // Ganshoren
  '21010', // Jette
  '21006', // Evere
  '21019', // Sint-Pieters-Woluwe
  '21002', // Oudergem,
  '21017', // Watermaal-Bosvoorde
  '21016', // Ukkel
  '21007', // Vorst
  '21018', // Sint-Lambrechts-Woluwe
  '21014', // Sint-Joost-ten-Node
]
// TODO Make separate gridOperators imports or place them in config: excessive render of objects //
export const getGridOperatorByMunicipalityCode = ({ code }) => {
  const vlaanderenOP = municipalityCodesBrussel.includes(code) ? 'Sibelga' : code.length > 4 ? 'Fluvius' : ''

  return  vlaanderenOP || primaryGridOperatorByMunicipalityCode[code] || ''
}

// used in reporting:
export function getGridOperators () {
  if (isVlaanderen) {
    return [
      { text: 'Sibelga', value: 'Sibelga' },
      { text: 'Fluvius', value: 'Fluvius' },
    ]
  }

  const operators = new Set()
  Object.values(primaryGridOperatorByMunicipalityCode).forEach(operator => operators.add(JSON.stringify(operator)))

  return Array.from(operators).map(operator => {
    const parsedOperator = JSON.parse(operator)   
      return {text: parsedOperator.name, value: parsedOperator.name }
    })
}
